// src/components/NavigationButtons/NavigationButtons.js

import React from "react";
import "./NavigationButtons.css";

import { ReactComponent as ArrowLeft } from "assets/icons/arrow-left.svg";
import { ReactComponent as ArrowRight } from "assets/icons/arrow-right.svg";

const NavigationButtons = ({
  currentStep,
  onPrevious,
  onNext,
  onSubmit,
  isPreviousDisabled,
  isNextDisabled,
  isLastStep,
}) => {
  return (
    <div className="navigaton-container">
      <div className={`navigation-buttons ${currentStep !== 1 ? "no-skip" : ""}`}>
        <div className="back-group" onClick={onPrevious} disabled={isPreviousDisabled}>
          <a className="back-arrow button"><ArrowLeft className="arrow-icon" />Back</a>
        </div>
          <>
            <div className="next-group">
              <a className={`next-arrow button ${isNextDisabled ? "disabled" : ""}`} onClick={isLastStep ? onSubmit : onNext}>
                  Next <ArrowRight className="arrow-icon" />
              </a>
            </div>
            {/* Skip is only for first question so value hardcoded*/}
            {currentStep === 1 && (
              <div className="skip-group">
                <a
                  className="skip-button"
                  onClick={onNext}
                >
                  Skip
                </a>
              </div>
            )}
          </>
      </div>
    </div>
  );
};

export default NavigationButtons;
